const subscriptions = {
  FETCH_SUBSCRIPTION: 'FETCH_SUBCRIPTION',
};

export default subscriptions;
